function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module undo/undoediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import UndoCommand from './undocommand';
import RedoCommand from './redocommand';
/**
 * The undo engine feature.
 *
 * It introduces the `'undo'` and `'redo'` commands to the editor.
 *
 * @extends module:core/plugin~Plugin
 */

var UndoEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(UndoEditing, _Plugin);

  var _super = _createSuper(UndoEditing);

  /**
   * @inheritDoc
   */
  function UndoEditing(editor) {
    var _this;

    _classCallCheck(this, UndoEditing);

    _this = _super.call(this, editor);
    /**
     * The command that manages undo {@link module:engine/model/batch~Batch batches} stack (history).
     * Created and registered during the {@link #init feature initialization}.
     *
     * @private
     * @member {module:undo/undocommand~UndoCommand} #_undoCommand
     */

    /**
     * The command that manages redo {@link module:engine/model/batch~Batch batches} stack (history).
     * Created and registered during the {@link #init feature initialization}.
     *
     * @private
     * @member {module:undo/undocommand~UndoCommand} #_redoCommand
     */

    /**
     * Keeps track of which batches were registered in undo.
     *
     * @private
     * @member {WeakSet.<module:engine/model/batch~Batch>}
     */

    _this._batchRegistry = new WeakSet();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(UndoEditing, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor; // Create commands.

      this._undoCommand = new UndoCommand(editor);
      this._redoCommand = new RedoCommand(editor); // Register command to the editor.

      editor.commands.add('undo', this._undoCommand);
      editor.commands.add('redo', this._redoCommand);
      this.listenTo(editor.model, 'applyOperation', function (evt, args) {
        var operation = args[0]; // Do not register batch if the operation is not a document operation.
        // This prevents from creating empty undo steps, where all operations where non-document operations.
        // Non-document operations creates and alters content in detached tree fragments (for example, document fragments).
        // Most of time this is preparing data before it is inserted into actual tree (for example during copy & paste).
        // Such operations should not be reversed.

        if (!operation.isDocumentOperation) {
          return;
        }

        var batch = operation.batch;

        var isRedoBatch = _this2._redoCommand._createdBatches.has(batch);

        var isUndoBatch = _this2._undoCommand._createdBatches.has(batch);

        var isRegisteredBatch = _this2._batchRegistry.has(batch); // If changes are not a part of a batch or this is not a new batch, omit those changes.


        if (isRegisteredBatch || batch.type == 'transparent' && !isRedoBatch && !isUndoBatch) {
          return;
        } else {
          if (isRedoBatch) {
            // If this batch comes from `redoCommand`, add it to `undoCommand` stack.
            _this2._undoCommand.addBatch(batch);
          } else if (!isUndoBatch) {
            // A default batch - these are new changes in the document, not introduced by undo feature.
            // Add them to `undoCommand` stack and clear `redoCommand` stack.
            _this2._undoCommand.addBatch(batch);

            _this2._redoCommand.clearStack();
          }
        } // Add the batch to the registry so it will not be processed again.


        _this2._batchRegistry.add(batch);
      }, {
        priority: 'highest'
      });
      this.listenTo(this._undoCommand, 'revert', function (evt, undoneBatch, undoingBatch) {
        _this2._redoCommand.addBatch(undoingBatch);
      });
      editor.keystrokes.set('CTRL+Z', 'undo');
      editor.keystrokes.set('CTRL+Y', 'redo');
      editor.keystrokes.set('CTRL+SHIFT+Z', 'redo');
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'UndoEditing';
    }
  }]);

  return UndoEditing;
}(Plugin);

export { UndoEditing as default };